import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const CollectionCard = ({ name, slug, description, image, alt, ctaLabel }) => (
  <article className="news__item">
    <div className="news__item-content">
      <div className="news__item-date">&nbsp;</div>
      <h2 className="news__item-headline">
        <Link className="news__item-headline-link" to={`/browse-styles/${slug}`}>
          {name}
        </Link>
      </h2>
      <p className="news__item-text">{description}</p>
      <Link className="news__item-more" to={`/browse-styles/${slug}`}>
        {ctaLabel}
      </Link>
    </div>
    <div className="news__item-media">
      <Link className="news__item-media-link" to={`/browse-styles/${slug}`}>
        <img className="news__item-media-image" alt={alt} width="356" height="183" src={image} />
      </Link>
    </div>
  </article>
);

CollectionCard.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
};

const PremiumCollectionPage = () => {
  const { find, meta } = usePageContent('premium-collection');
  const seo = meta?.seo;
  const intro = find('richText') || {};
  const cardsData = find('collectionCards') || {};
  const footer = find('footerCta') || {};
  const cards = cardsData.cards || [];
  const ctaLabel = cardsData.cardCtaLabel || 'Learn more';

  useTitle(seo?.title || intro.pageTitle || 'The Premium Collection');
  useMeta(seo);

  return (
    <div id="content" className={styles.page}>
      <div className={`page-header page-header--premium ${styles.premiumHeader}`}>
        <div className="content-holder content-holder--indented">
          <h1 className="page-header__title">{intro.pageTitle || 'The Premium Collection'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text">
          {intro.richTextHtml && (
            <div dangerouslySetInnerHTML={{ __html: intro.richTextHtml }} />
          )}
          {cards.map((card) => (
            <CollectionCard
              key={card.slug}
              name={card.name}
              slug={card.slug}
              description={card.description}
              image={card.image}
              alt={card.alt}
              ctaLabel={ctaLabel}
            />
          ))}
          {footer.richTextHtml && (
            <div dangerouslySetInnerHTML={{ __html: footer.richTextHtml }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PremiumCollectionPage;
